export interface WithdrawalsPolicyForm {
  chargeShipping: boolean;
  policyCoverage: boolean;
}

export function buildPolicy(
  form: WithdrawalsPolicyForm,
  withdrawalPortalLink: string,
): string {
  const shipping = form.chargeShipping
    ? "Please note that under Article 14(1) of Directive 2011/83/EU, customers are responsible for the cost of return shipping. A prepaid label will be provided through our withdrawal portal; the label cost will be deducted from your refund."
    : "We will cover the cost of return shipping at no cost to you. A prepaid label will be provided through our withdrawal portal.";

  const paragraphs = [
    "Under the EU Consumer Rights Directive, you have the right to withdraw from many contracts within 14 days of receiving your order, without providing any reason.",
    `To exercise your right of withdrawal, click here: ${withdrawalPortalLink}`,
    shipping,
  ];

  if (form.policyCoverage) {
    paragraphs.push(
      "At checkout, you may add withdrawal coverage to your order. If you purchased withdrawal coverage, your return shipping is fully covered at no additional cost when you exercise your right of withdrawal. Please note that customers who do not purchase withdrawal coverage are responsible under Article 14(1) of Directive 2011/83/EU for the cost of return shipping. A prepaid label will be provided through our withdrawal portal; the label cost will be deducted from your refund.",
    );
  }

  paragraphs.push(
    "We will issue your refund within fourteen (14) days of receiving notification of your cancellation, or, if later, once we have received the returned goods or you have provided proof that the goods have been shipped back to us.",
  );
  paragraphs.push(
    "This right applies to all items purchased through our store, with certain exceptions such as digital products, perishable goods, sealed personal hygiene products, and personalized items, as set forth in Article 16 of Directive 2011/83/EU.",
  );

  return `Right of Withdrawal\n\n${paragraphs.join("\n\n")}`;
}
